module.exports = __webpack_public_path__ + "bd9a6a9d9eb35e512d6efc97d3ca5a17.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/destructive_abilities-320.jpg
// module id = 248
// module chunks = 0